/** Small formatters shared by the Email, Money and Settings screens. */

import { fmtDate, fmtWhen } from "../../data/format";

const INT = new Intl.NumberFormat("en-US");
const USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const USD_WHOLE = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export const when = fmtWhen;

/** "11 Oct 2026"; null for a missing or bad stamp. */
export function day(iso: string | null | undefined): string | null {
  const out = fmtDate(iso);
  return out === "—" ? null : out;
}

export function num(value: number): string {
  return INT.format(value);
}

/** A Decimal-as-string (or number) as dollars; "" when unknown. */
export function usd(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? USD.format(n) : "";
}

/** Whole dollars, for a total ("$636,800"). */
export const whole = (value: number): string => USD_WHOLE.format(value);

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${num(n)} ${n === 1 ? one : many}`;
}

export function bytes(n: number | null): string {
  if (n === null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** "admin" as "Admin". */
export const capitalise = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

/** Whole days from the ISO day to today (local); null for a bad date. */
export function daysSince(iso: string): number | null {
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return null;
  const today = new Date();
  return Math.round((new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() - new Date(y, m - 1, d).getTime()) / 86_400_000);
}
